export const axiosDefaultTimeout = 15; // seconds

export const defaultLang = 'uk';
export const availableLanguages = ['ru', 'en', 'uk'];

// in seconds
export const cacheTimeouts = {
  payWay: 10,
  payMethodPayWays: 10,
  payMethods: 10,
  warning: 20,
  description: 20,
  manual: 20,
};

export const invoiceStatuses = {
  success: 1,
  fail: 2,
  inProcess: 3,
};
